import { createSlice } from '@reduxjs/toolkit'
import { setIsClearingReduxFormState } from 'state/ui'

const initialState = {
  inboundTicketId: '',
  transportationInformation: {
    purchaseOrderNumber: undefined,
    purchaseOrderId: undefined,
    scrapVehicles: [],
    newScrapVehicle: {},
    scrapVehiclesWereEdited: false,
  },
  newCustomerVehicle: {
    id: '',
    label: '',
  },
  activeDialogState: undefined,
  submittedFromDispatchBlade: false,
}

export const inboundTicketSlice = createSlice({
  name: 'inboundTicket',
  initialState,
  reducers: {
    setPurchaseOrderInfo: (state, action) => {
      state.transportationInformation.purchaseOrderNumber = action.payload.purchaseOrderNumber
      state.transportationInformation.purchaseOrderId = action.payload.purchaseOrderId
    },
    clearTransportationInformation: state => {
      state.transportationInformation = initialState.transportationInformation
    },
    setScrapVehicles: (state, action) => {
      state.transportationInformation.scrapVehicles = action.payload
    },
    addScrapVehicle: (state, action) => {
      const currentScrapVehicles = state.transportationInformation.scrapVehicles
      state.transportationInformation.scrapVehicles = [...currentScrapVehicles, action.payload]
      state.transportationInformation.newScrapVehicle = action.payload
    },
    updateScrapVehicle: (state, action) => {
      const currentScrapVehicles = state.transportationInformation.scrapVehicles
      const scrapVehicleIndex = currentScrapVehicles.findIndex(
        scrapVehicle => scrapVehicle.rowId === action.payload.rowId,
      )
      currentScrapVehicles[scrapVehicleIndex] = action.payload
      state.transportationInformation.scrapVehicles = currentScrapVehicles
      state.transportationInformation.scrapVehiclesWereEdited = true

      state.transportationInformation.newScrapVehicle = action.payload
    },
    resetScrapVehiclesEdited: state => {
      state.transportationInformation.scrapVehiclesWereEdited =
        initialState.transportationInformation.scrapVehiclesWereEdited
    },
    removeScrapVehicle: (state, action) => {
      const currentScrapVehicles = state.transportationInformation.scrapVehicles
      state.transportationInformation.scrapVehicles = currentScrapVehicles.filter(
        scrapVehicle => scrapVehicle.rowId !== action.payload,
      )
    },
    setNewCustomerVehicle: (state, action) => {
      state.newCustomerVehicle = action.payload
    },
    clearNewCustomerVehicle: state => {
      state.newCustomerVehicle = initialState.newCustomerVehicle
    },
    setActiveDialogState: (state, action) => {
      state.activeDialogState = action.payload
    },
    clearActiveDialogState: state => {
      state.activeDialogState = initialState.activeDialogState
    },
    setSubmittedFromDispatchBlade: (state, action) => {
      state.submittedFromDispatchBlade = action.payload
    },
    clearSubmittedFromDispatchBlade: state => {
      state.submittedFromDispatchBlade = initialState.submittedFromDispatchBlade
    },
    setInboundTicketId: (state, action) => {
      state.inboundTicketId = action.payload
    },
    clearInboundTicketId: state => {
      state.inboundTicketId = initialState.inboundTicketId
    },
  },
  extraReducers: builder => {
    builder.addCase(setIsClearingReduxFormState, (state, action) => {
      if (action.payload) {
        state.inboundTicketId = initialState.inboundTicketId
        state.transportationInformation = initialState.transportationInformation
        state.newCustomerVehicle = initialState.newCustomerVehicle
        state.activeDialogState = initialState.activeDialogState
        state.submittedFromDispatchBlade = initialState.submittedFromDispatchBlade
      }
    })
  },
})

export const {
  setPurchaseOrderInfo,
  clearTransportationInformation,
  setScrapVehicles,
  addScrapVehicle,
  updateScrapVehicle,
  removeScrapVehicle,
  setNewCustomerVehicle,
  clearNewCustomerVehicle,
  setActiveDialogState,
  clearActiveDialogState,
  resetScrapVehiclesEdited,
  setSubmittedFromDispatchBlade,
  clearSubmittedFromDispatchBlade,
  setInboundTicketId,
  clearInboundTicketId,
} = inboundTicketSlice.actions

export default inboundTicketSlice.reducer
